import Add16 from '@carbon/icons-react/es/add/16';
import React, { FC, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { UserType } from 'api/models';
import { Button } from 'components/atoms/button';
import { Option } from 'components/atoms/select';
import { SingleLineOption } from 'components/atoms/select/custom-components';
import { TitleSelect } from 'components/organisms/timesheets/common/title-select';
import { AssignProjectRow } from '../../../resource-types';

const Wrapper = styled.div`
  padding-left: var(--spacing-08);
`;

interface Props
  extends Pick<
    AssignProjectRow,
    'alreadyAssignedProjectIds' | 'userId' | 'userType' | 'company'
  > {
  projectOptions: Option<{ partners: number[] }>[];
  onProjectAssign: (userId: number, projectId: number) => void;
}
export const AssignProject: FC<Props> = ({
  alreadyAssignedProjectIds,
  projectOptions,
  userId,
  userType,
  company: { companyId },
  onProjectAssign,
}) => {
  const options = useMemo(
    () =>
      projectOptions.filter(
        ({ value, extra }) =>
          !alreadyAssignedProjectIds.includes(Number(value)) &&
          (userType === UserType.Partner
            ? extra?.partners.includes(companyId)
            : true),
      ),
    [alreadyAssignedProjectIds, companyId, projectOptions, userType],
  );

  return (
    <TitleSelect
      triggerComponent={() => (
        <Wrapper>
          <Button type="link" icon={<Add16 />} iconPlacement="right">
            <FormattedMessage id="resource_management.actions.assign_project_to_user" />
          </Button>
        </Wrapper>
      )}
      onChange={(selected) => {
        if (selected) {
          onProjectAssign(userId, Number(selected.value));
        }
      }}
      options={options}
      components={{
        Option: SingleLineOption,
      }}
      selected={{ value: -1, label: 'default' }}
    />
  );
};
